module.exports = __webpack_public_path__ + "img/icon03.04b46d83.png";